<ng-container>
  @if (editing && permissions) {

    <div class="form-group row align-items-center">
      @if (showLabel) {
<label [class]="labelClass" class="col-form-label block bold">{{label}}@if (required==true) {
<span class="text-danger">*</span>
} :</label>
}
      <div [class]="formClass">
          <input
            class="form-control-plaintext editable-field"
            #inlineEditControl
            [required]="required"
            (click)="$event.stopPropagation()"
            (keyup)="checkPattern($event)"
            [maxLength]="maxLength"
            [disabled]="!item.editable"
            id="selectedId"
            [pattern]="pattern"
            [name]="value"
            [(ngModel)]="value"
            [type]="type"
            [placeholder]="label"
          />
          <span (click)="onBlur()" id="saveDiv" class="save"></span>
          <span (click)="previousValue($event)" id="rejectDiv" class="reject"></span>
          @if (required==true && value == '') {
<div>
            <small class="text-danger">Please enter {{label}}</small>
          </div>
}
          @if (patternValidation) {
<div>
            <small class="text-danger" style="text-transform: lowercase">Only {{item.type}} allowed</small>
          </div>
}
      </div>
    </div>
  
}
  @if (!editing) {

    <div class="form-group row align-items-center height-38">
      @if (showLabel) {
<label [class]="labelClass" class="col-form-label block bold">{{label}}@if (required==true) {
<span class="text-danger">*</span>
} :</label>
}
      <div [class]="formClass">
        <div (click)="edit(value)" (focus)="edit(value);" tabindex="0"
             [ngClass]="{'inline-edit': permissions, 'inline-edit-hover': item.editable}" class="form-control-plaintext">
          @if (!item.editable) {

            @if (value && item.type == 'DATE') {
<span ngbTooltip="View Only" placement="right" >{{value | date: dateFormat}}&nbsp;</span>
}
            @if (value && item.type != 'DATE') {
<span ngbTooltip="View Only" placement="right" >{{value}}&nbsp;</span>
}
            @if (!value) {
<span ngbTooltip="View Only" placement="right" >--</span>
}
          
}
          @if (item.editable) {

            @if (value && item.type == 'DATE') {
<span class="edit-text">{{value | date: dateFormat | ellipses:20}}</span>
}
            @if (value && item.type != 'DATE') {
<span class="edit-text">{{value | ellipses:17}}</span>
}
            @if (!value) {
<span class="link-color edit-text">click to set</span>
}
          
}
          <span class="edit-icon"></span>
        </div>
      </div>
    </div>
  
}
</ng-container>
